import React from "react";

const PrimaryHeader = ({ children }) => (
  <div className="header__primary">
    <div className="content-body">{children}</div>
  </div>
);
export default PrimaryHeader;
